import AboutPage from "./about";

export default AboutPage;